import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { whatsappLink } from "@/constants/site";
import { logoPortfolio, logoServices } from "@/mocks/criacao-sites";

export default function LogoPortfolio() {
  return (
    <section id="logotipo" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Identidade visual"
          badgeIcon="ri-palette-line"
          badgeTone="secondary"
          title="Criação de Logotipo e Identidade Visual"
          description="Uma marca forte começa por um bom logotipo. Criamos identidades visuais profissionais que traduzem o posicionamento da sua empresa em símbolos, cores e tipografia."
        />

        <div className="mt-12 grid grid-cols-2 gap-5 sm:grid-cols-3">
          {logoPortfolio.map((logo, index) => (
            <Reveal key={logo.name} delay={index * 60} className="h-full">
              <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-100/40 transition-colors hover:border-primary-200">
                <div className="flex aspect-square w-full items-center justify-center bg-background-50 p-6">
                  <img
                    src={logo.image}
                    alt={`Logotipo criado para a marca fictícia ${logo.name}`}
                    title={`${logo.name} — criação de logotipo NXHOST`}
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                </div>
                <div className="p-4 text-center">
                  <p className="font-heading text-sm font-semibold text-foreground-950">
                    {logo.name}
                  </p>
                  <p className="mt-1 text-[11px] uppercase tracking-wide text-foreground-500">
                    {logo.segment}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 rounded-2xl border border-background-200 bg-background-100/60 p-6 md:p-8 lg:grid-cols-[1fr_0.85fr] lg:items-center">
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950">
              O que está incluído na criação da marca
            </h3>
            <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {logoServices.map((service) => (
                <div
                  key={service}
                  className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-sm font-medium text-foreground-700"
                >
                  <i className="ri-check-line text-lg text-primary-600" aria-hidden="true"></i>
                  {service}
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-6">
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100/70 text-primary-700">
              <i className="ri-quill-pen-line text-2xl" aria-hidden="true"></i>
            </span>
            <p className="text-sm leading-relaxed text-foreground-600">
              Quer uma marca que represente o seu negócio com profissionalismo? Fale com a gente e
              receba uma proposta para o seu logotipo e identidade visual.
            </p>
            <a
              href={whatsappLink(
                "Ola! Quero criar o logotipo e a identidade visual da minha empresa com a NXHOST."
              )}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
              Quero criar meu logotipo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}